import React from 'react';

const ReorderButton = ({
  label,
  title,
  cssClass,
  orderId,
  rowIndex,
  quanity,
  onClick,
}) => (
  <button
    className={cssClass}
    type="button"
    title={title}
    onClick={() => {
      onClick(orderId, rowIndex, quanity);
    }}
  >
    {label}
  </button>
);
export default ReorderButton;
